import { Link as RouterLink, } from 'react-router-dom';
import { Link, Typography, } from '@mui/material';
import { useAuth, } from '../../hooks';
import { LogoIcon, } from '../custom-svg';

export default function LogoDesktop() {
    const { user, } = useAuth();

    return (
        <Link
            component={RouterLink}
            to={user ? '/latest' : '/'}
            underline='none'
            sx={{
                alignItems: 'center',
                display: { xs: 'none', lg: 'flex' },
                mr: 3.5,
                '&:hover': {
                    '& .MuiSvgIcon-root, & .MuiTypography-root': {
                        color: 'secondary.main',
                    },
                },
            }}
        >
            <LogoIcon sx={{ color: 'text.primary', fontSize: 28, mr: 1.25, }} />
            <Typography variant='logo' sx={{ color: 'text.primary', }}>cards</Typography>
        </Link>
    );
}